import React from 'react'
import ReactDOM from 'react-dom'
import AppRoutes from 'src/routes/AppRoutes'
import { Amplify } from 'aws-amplify'
import { CookieStorage } from 'aws-amplify/utils'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID as string,
      userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID as string
    }
  },
  storage: CookieStorage
})

ReactDOM.render(
  <React.StrictMode>
    <AppRoutes />
  </React.StrictMode>,
  document.getElementById('root')
)
